import createVueComponent from '../createVueComponent';

const Clock3 = createVueComponent('Clock3Icon', [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['polyline', { points: '12 6 12 12 16.5 12' }],
]);

export default Clock3;
